import type { LocationFilters } from '@models/location'
import { keyToUrl } from '@tools/common'
import { omit } from 'lodash'

export const locationsKeys = {
  root: (companyId: number) => ['companies', companyId, 'locations'] as const,
  location: (companyId: number, id: number) =>
    [...locationsKeys.root(companyId), id] as const,
  list: (filters: LocationFilters) =>
    [
      ...locationsKeys.root(filters.companyId),
      omit(filters, ['companyId', 'page', 'limit']),
      { page: filters.page, limit: filters.limit },
    ] as const,
}

export const locationsUrls = {
  root: (companyId: number) => keyToUrl(locationsKeys.root(companyId)),
  location: (companyId: number, id: number) =>
    keyToUrl(locationsKeys.location(companyId, id)),
}
